export default "__VITE_ASSET__U_vW1TCY__"